import { Component, OnInit, Input } from '@angular/core';
import { MainPageService } from '../../../../main-page/main-page.service';
import { PipesManagmentComponent } from '../pipes-managment/pipes-managment.component';
import { PipeModel } from '../../../../models/parts/pipe.model';
declare var $: any;

@Component({
  selector: 'app-pipes-grid',
  template: `<!-- Delete Modal -->
<div class="modal" id="deleteModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this Pipe?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="deletePipe()">Delete</button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="!isPipeChoosen">
    <div class="input-effect">
        <input class="effect1" type="text" placeholder="">
        <label>Search</label>
        <span class="focus-border"></span>
    </div>
    <button class="red-button" type="button" data-toggle="modal" data-target="#addModal" (click)="createNewPipe()">Create</button>

    <table>
        <tr>
            <th *ngFor="let header of headers">{{header}}</th>
        </tr>
        <tr *ngFor="let pipe of pipesGridData, let row_no = index">
            <td>{{pipe.name}}</td>
            <td>{{pipe.description}}</td>
            <td class="columnWithIcons">
                <button type="button" class="btn editBtn" (click)="editPipe(pipe)">
                    <i class="fa fa-edit"></i>
                </button>
                <button type="button" class="btn deleteBtn" data-toggle="modal" data-target="#deleteModal" (click)="setChoosenElement(pipe)">
                    <i class="fa fa-trash"></i>
                </button>
            </td>
        </tr>
    </table>
</div>`,
  styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.modal-label{width:110px}.display-flex{display:flex;align-items:center;margin-bottom:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}`]
})
export class PipesGridComponent implements OnInit {
  @Input() managmentComponent: PipesManagmentComponent;
  isPipesHidden = true;
  pipesGridData: PipeModel[];
  selectedPipe: PipeModel;
  isPipeChoosen: boolean = false;
  elementIndex: number;
  headers: string[] = ['Name', 'Description', ''];

  constructor(private mainPageService: MainPageService) { }

  public ngOnInit(): void {
    this.loadGridDataFromDb();
    this.mainPageService.deletePipeSubject.subscribe((value) => {
      this.pipesGridData = this.pipesGridData.filter(x => x._id !== value);
    });
    this.managmentComponent.stateSubject.subscribe((state) => {
      if (state !== null) {
        Object.assign(this.pipesGridData[this.elementIndex], state);
      }
      this.isPipeChoosen = false;
    });
  }

  loadGridDataFromDb() {
    this.mainPageService.loadAllPipes().subscribe((response) => {
      this.pipesGridData = response.sort(function (a, b) {
        return (a.name < b.name) ? -1 : 1;
      });
    });
  }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
      $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isPipesHidden = !this.isPipesHidden;
  }

  createNewPipe() {
    const pipe = new PipeModel();
    this.mainPageService.addNewPipeIntoDb(JSON.stringify(pipe)).subscribe((response) => {
      pipe._id = response._id;
      pipe.id = response.id;
      this.pipesGridData.push(pipe);
      this.elementIndex = this.pipesGridData.indexOf(pipe);
      this.managmentComponent.showManagmentPage(pipe, true);
    });
    this.isPipeChoosen = true;
  }

  setChoosenElement(element) {
    this.selectedPipe = {
      ...element,
    };
    this.elementIndex = this.pipesGridData.indexOf(element);
  };

  editPipe(element) {
    this.selectedPipe = {
      ...element,
    };
    this.elementIndex = this.pipesGridData.indexOf(element);
    this.managmentComponent.showManagmentPage(this.selectedPipe, false);
    this.isPipeChoosen = true;
  }

  deletePipe() {
    this.mainPageService.removePipe(this.selectedPipe._id).subscribe(() => { }, () => { });
    this.mainPageService.deletePipeSubject.next(this.selectedPipe._id);
  }
}
